export default () => {
    const aliasDeleteModal = document.getElementById('aliasDeleteModal');
    if (!aliasDeleteModal) {
        return;
    }
    aliasDeleteModal.addEventListener('show.bs.modal', (event) => {
        const button = event.relatedTarget;
        const {
            email, alias, action, redirect
        } = button.dataset;

        aliasDeleteModal.querySelector('#aliasDelete').setAttribute('action', action);
        aliasDeleteModal.querySelector('#email').value = email;
        aliasDeleteModal.querySelector('#alias').value = alias;
        aliasDeleteModal.querySelector('#redirect').value = redirect;
    });
};
